<template>
  <div>
    <div class="cta-wrapper d-flex align-items-center justify-content-center mx-auto mx-md-n3 mx-lg-auto my-3 my-lg-4 my-md-4 text-muted">
      <div class="d-flex align-items-center position-relative">
        <div @click.prevent="open" style="cursor: pointer;" class="image-wrapper image-wrapper-1 d-flex align-items-end justify-content-center rounded pl-1" :style="{'background-image': `url('/images/designify-cta/${imageType}/bg_1.jpg')`}">
          <img :src="image" class="img-fluid" :class="`align-${imageType}`"/>
        </div>
        <div @click.prevent="open" style="cursor: pointer;" class="image-wrapper image-wrapper-2 d-flex align-items-end justify-content-center rounded pl-1" :style="{'background-image': `url('/images/designify-cta/${imageType}/bg_2.jpg')`}">
          <img :src="image" class="img-fluid" :class="`align-${imageType}`"/>
        </div>
        <div @click.prevent="open" style="cursor: pointer;" class="image-wrapper image-wrapper-3 d-flex align-items-end justify-content-center rounded pl-1" :style="{'background-image': `url('/images/designify-cta/${imageType}/bg_3.jpg')`}">
          <img :src="image" class="img-fluid" :class="`align-${imageType}`"/>
        </div>
      </div>
      <a href="#" @click.prevent="open" class="small text-decoration-none pl-2 text-left text-muted d-inline-block text-nowrap">
        {{ t.below_button_cta_text }}
      </a>
    </div>
    <transition name="fade">
      <div v-show="show" :id="`designify-cta-popup-${remoteId}`" class="white-popup rounded-lg shadow text-center designify-cta-popup">
        <h5 class="mb-4 mt-2">{{ t.below_button_cta_modal_title }} <span class="badge badge-danger ml-1" style="background: #FF7272; color: white; font-family: 'Open Sans'">{{ t.free }}</span></h5>
        <div class="d-flex justify-content-center mb-4">
          <div @click="reportAndOpen" style="cursor: pointer;" class="image-wrapper-dialog image-wrapper d-flex align-items-end justify-content-center rounded flex-shrink-0 pl-1 mr-2" :style="{'background-image': `url('/images/designify-cta/${imageType}/bg_1.jpg')`}">
            <img :src="image" class="img-fluid" :class="`align-${imageType}`"/>
          </div>
          <div @click="reportAndOpen" style="cursor: pointer;" class="image-wrapper-dialog image-wrapper d-flex align-items-end justify-content-center rounded flex-shrink-0 pl-1 mr-2" :style="{'background-image': `url('/images/designify-cta/${imageType}/bg_2.jpg')`}">
            <img :src="image" class="img-fluid" :class="`align-${imageType}`"/>
          </div>
          <div @click="reportAndOpen" style="cursor: pointer;" class="image-wrapper-dialog image-wrapper d-flex align-items-end justify-content-center rounded flex-shrink-0 pl-1 mr-2" :style="{'background-image': `url('/images/designify-cta/${imageType}/bg_3.jpg')`}">
            <img :src="image" class="img-fluid" :class="`align-${imageType}`" />
          </div>
        </div>
        <div style="font-size: 60%; opacity: 0.5;" class="mt-4 text-center mx-auto">
          <span v-html="t.below_button_cta_modal_text_html" class="link-dark highlight-front"></span>
        </div>


        <div class="mt-4 pb-2 align-items-center justify-content-between">
          <a href="#" @click.prevent="reportAndOpen" target="_blank" rel="noopener noreferer" class="btn btn-primary text-white">{{ t.use_it_in_designify }}</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    imageType: String,
    originalImage: String,
    t: Object,
    remoteId: String,
  },
  data() {
    return {
      isOpen: false,
      openDelay: 2500,
    }
  },

  computed: {
    show() {
      return this.isOpen
    },
    url() {
      const content = this.t.variant;
      const url = new URL(this.t.link);

      url.searchParams.append("imageurl", this.originalImage);
      url.searchParams.append("utm_medium", "referral");
      url.searchParams.append("utm_source", "dfy preview");
      url.searchParams.append("utm_campaign", "rbg referral");
      url.searchParams.append("utm_content", content);

      return url.href
    }
   },
   methods: {
    open() {
      const self = this;

      $.magnificPopup.open({
        items: {
          src: `#designify-cta-popup-${this.remoteId}`
        },
        type: "inline",
        callbacks: {
          open: function() {
            self.isOpen = true
          },

          close: function() {
            this.isOpen = false
          }
        }
      })
      this.isOpen = true
    },
    close() {
      $.magnificPopup.close()
      this.isOpen = false
    },
    reportAndOpen() {
       reportSplit("designify_below_button_cta_round_3", null, false);
       window.open(this.url);
       this.close();
    }
  }
}
</script>

<style lang="scss" scoped>

.designify-cta-popup {
  max-width: 330px;
}

.cta-wrapper {
  max-width: 220px;
  flex-basis: 100%;
}

.image-wrapper {
  overflow: hidden;
  border: 0.5px solid white;
  background-position: center;
  background-size: cover;

  &.image-wrapper-1 {
    width: 47px;
    height: 47px;
    z-index: 3;

    img {
      max-height: 47px;
    }
  }

  &.image-wrapper-2 {
    width: 43px;
    height: 43px;
    margin-left: -29.5px;
    z-index: 2;

    img {
      max-height: 43px;
    }
  }

  &.image-wrapper-3 {
    width: 39px;
    height: 39px;
    margin-left: -28px;
    z-index: 1;

    img {
      max-height: 39px;
    }
  }
}

.image-wrapper-dialog {
  overflow: hidden;
  border: 0.5px solid white;
  background-position: center;
  background-size: cover;

  &.image-wrapper {
    width: 72px;
    height: 72px;
    img {
      max-height: 72px;
    }
  }

  img {
    display: block;
    object-fit: contain;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.align-car {
  padding: 10px 2px 5px 2px;
}
</style>
<style>
.link-dark a{
  color: #454545!important;
  font-weight: 700!important;
}
</style>
